import { gql } from "@apollo/client";

export const HANDLE_USER_SUBSCRIPTION = gql`
	mutation HandleUserSubscription {
		handleUserSubscription {
			code
			success
			message
		}
	}
`;

export const RENDER_PDF_EXPORT = gql`
	mutation RenderPDFExport($tripId: ID!) {
		renderPDFExport(tripId: $tripId)
	}
`;

export const RENDER_PDF_EXPORT_ASYNC = gql`
	mutation RenderPDFExportAsync($tripId: ID!) {
		renderPDFExportAsync(tripId: $tripId) {
			jobId
			status
			message
		}
	}
`;

export const HANDLE_SCRATCH_MAP = gql`
	mutation HandleScratchMap($countryCode: String!, $state: String!) {
		handleScratchMap(countryCode: $countryCode, state: $state) {
			_id
			scratchMapCountries {
				countryCode
				state
			}
		}
	}
`;
